(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const body = document.body;

  const setHeaderState = () => {
    const scrolled = window.scrollY > 72;
    body.classList.toggle('rq-header-scrolled', scrolled);
    document.querySelectorAll('#header-component, header-component').forEach((header) => {
      header.toggleAttribute('data-rq-compact', scrolled);
    });
  };

  let headerTicking = false;
  const onScroll = () => {
    if (headerTicking) return;
    headerTicking = true;
    window.requestAnimationFrame(() => {
      setHeaderState();
      headerTicking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  setHeaderState();

  const lockBody = (locked) => {
    body.classList.toggle('rq-drawer-open', locked);
    body.style.overflow = locked ? 'hidden' : '';
  };

  const syncDrawers = () => {
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    const openDrawer = document.querySelector('dialog[open], details[open].menu-drawer, .cart-drawer[open], cart-drawer-component[open], menu-drawer[open], .drawer[open]');
    lockBody(Boolean(openDrawer));
  };

  document.addEventListener('toggle', (event) => {
    if (event.target.matches('details, dialog')) syncDrawers();
  }, true);

  document.addEventListener('click', () => {
    window.requestAnimationFrame(syncDrawers);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') window.requestAnimationFrame(syncDrawers);
  });

  window.addEventListener('pageshow', syncDrawers);

  document.querySelectorAll('.rq-accordions details').forEach((details) => {
    details.classList.add('rq-accordion-animate');
  });

  if (reducedMotion || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.rq-reveal').forEach((element) => element.classList.add('is-visible'));
    return;
  }

  const revealSelectors = [
    '.rq-visual__content',
    '.rq-edit h2',
    '.rq-edit__intro',
    '.rq-discovery__item',
    '.rq-benefits > div',
    '.rq-newsletter',
    '.rq-footer-grid > *',
    '.rq-collection__copy',
    '.rq-collection__media',
    '.rq-product-grid > li',
    '.rq-product__summary',
    '.rq-search__header',
    '.rq-search-grid > li',
    '.rq-cart__header',
    '.rq-cart-item',
    '.rq-cart__summary',
    '.rq-contact__header',
    '.rq-contact-form',
    '.rq-contact__aside',
    '.rq-not-found__inner'
  ].join(',');

  const revealItems = Array.from(document.querySelectorAll(revealSelectors)).filter((element) => {
    return !element.classList.contains('rq-no-reveal');
  });

  revealItems.forEach((element, index) => {
    const isHero = Boolean(element.closest('.rq-visual--hero'));
    const isInitiallyVisible = element.getBoundingClientRect().top < window.innerHeight * 0.72;
    if (isHero || isInitiallyVisible) {
      element.classList.add('is-visible');
      return;
    }
    element.classList.add('rq-reveal');
    const localIndex = index % 4;
    element.style.setProperty('--rq-reveal-delay', `${Math.min(localIndex * 45, 135)}ms`);
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.14,
    rootMargin: '0px 0px -8% 0px'
  });

  revealItems.forEach((element) => {
    if (element.classList.contains('rq-reveal')) observer.observe(element);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.rq-reveal').forEach((element) => {
      element.classList.add('is-visible');
    });
    event.target.querySelectorAll('.rq-accordions details').forEach((details) => {
      details.classList.add('rq-accordion-animate');
    });
  });
})();
